<div class="modal-header">
  <div>
    <h4 md-dialog-title class="modal-title pull-left" [innerHTML]="data.Header"></h4>
    <h6 md-dialog-title class="modal-title pull-left" [innerHTML]="data.SubHeader"></h6>
  </div>
</div>
<div class="modal-body">
  <mat-dialog-content>
    <div *ngIf="iframeUrl">
        <gsp-pdf-viewer (lastPageEvent)="lastPageEventClicked($event)" [pdfUrl]="this.iframeUrl.changingThisBreaksApplicationSecurity" #pdfViewer ></gsp-pdf-viewer>
    </div>
    <div *ngIf="data.Body" [innerHTML]="data.Body"></div>
    <div *ngIf="data.CustData" [innerHTML]="data.CustData"></div>
    <div *ngIf="data.IsAppeal">
      <div class="appealDesc" [innerHTML]="data.AppealText"></div>
      <div class="appeal-radio">
        <mat-radio-group aria-label="Select an option" [(ngModel)]="appealModal">
          <mat-radio-button *ngFor="let control of data.AppealControlArray" [value]="control.Action"
            [checked]="control.Action == appealModal">{{ control.Text }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div *ngIf="showError()">
      <br />
      <p [innerHtml]="getErrorMessage() | safeHtml"></p>
    </div>
    <div *ngIf="data.error && errorId" class="mt-2 mb-2">
      <b>Error Code:</b> {{ errorId }}
    </div>
    <div *ngIf="data.IsAgreementAllowed">
      <mat-checkbox role="none" type="checkbox" (ngModelChange)="isAcknoladge($event)" [ngModel]="isAcknowledgeChecked"
        id="AcknowledgeTerms">
        <span [innerHTML]="data.agreementText | safeHtml"></span>
      </mat-checkbox>
    </div>
  </mat-dialog-content>
</div>
<div class="modal-footer">
  <mat-dialog-actions class="btn-container button-actions w-100">
    <button [class.btn-primary]="control.Action === 'YES'" mat-raised-button
      [class.new-btn-continue]="control.Action === 'YES'" [class.new-btn-back]="control.Action !== 'YES'"
      [class.singleBtn]="data.ControlArray.length === 1" md-raised-button
      *ngFor="let control of data.ControlArray; let ftIndex = index" (click)="onClose(control.Action)"
      [disabled]="control.isDisabled" [innerHTML]="control.Text"></button>
  </mat-dialog-actions>
</div>